module.exports = __webpack_public_path__ + "img/edge_step_1.d2f23910.jpg";